<template>
  <div
    class="zt-badge relative m-1 inline-flex max-w-full cursor-default items-center overflow-hidden px-4 align-middle text-sm no-underline outline-none"
    :class="[shape]" :style="[colorStyle]">
    <span class="zt-badge-text inline-flex items-center">
      <slot />
    </span>
  </div>
</template>

<script>
export default {
  name: 'ztBadge',
  inheritAttrs: false,
}
</script>


